enum currencyType {
  EUR = "EUR",
  USD = "USD",
}

interface CardProps {
  currency?: currencyType;
  price: string;
  tag: string;
  name: string;
  description: string;
  buttonText?: string;
  actionSummary?: string;
  displayCurrencyName?: boolean;
  actionInformation: React.ReactElement;
  actionButton: React.ReactElement;
}

export default function PlanCard(props: CardProps) {
  const {
    currency,
    price,
    tag,
    name,
    description,
    displayCurrencyName,
    actionInformation,
    actionButton,
  } = props;

  const getCurrencySymbol = () => {
    return currency === currencyType.EUR ? "€" : "$";
  };

  const PricingTitle = () => {
    return (
      <div className="flex font-bold leading-10 space-x-1">
        <span className="text-4xl text-promGray4 leading-none">
          {getCurrencySymbol()}
        </span>
        <span className="text-5xl text-promGray2">{price}</span>
        {displayCurrencyName && (
          <span className="text-26px text-promGray4 leading-7">{currency}</span>
        )}
      </div>
    );
  };

  const Separator = ({ className }: { className?: string }) => {
    return (
      <div
        className={`w-12 border-b-4 h-1 border-promGray4 ${className ?? ""}`}
      />
    );
  };

  return (
    <div className={`border border-promGray2 rounded p-6 max-w-70 min-w-53`}>
      <PricingTitle />
      <div className="mt-3 mb-2 h-16">
        <div className="text-sm font-medium break-words">{tag}</div>
        <Separator className="mt-3" />
      </div>
      <div className="text-lg font-bold mb-3 break-words">{name}</div>
      <div className="font-medium mb-26px break-words h-10 text-sm">
        {description}
      </div>
      <div className="flex justify-center items-center w-full text-sm">
        {actionInformation}
      </div>
      <div className="flex justify-center">{actionButton}</div>
    </div>
  );
}

PlanCard.defaultProps = {
  currency: currencyType.EUR,
  displayCurrencyName: true,
};
